import React from 'react';
import { useTranslation } from 'react-i18next';
import reactStringReplace from 'react-string-replace';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';

import Link from '../../../components/Link';
import { useStyles } from './styles';
import Button from '../../Button';

import HANDSHAKE_ICON from '../../../images/icons/Interaction_Handshake.svg';
import CHAT_ICON from '../../../images/icons/Chat_Dual.svg';
import ENVELOPE_ICON from '../../../images/icons/Contact_Email.svg';
import { CardActions, CardContent } from '@material-ui/core';

const SupportCards = () => {
	const classes = useStyles();
	const { t } = useTranslation();

	return (
		<Grid container className={classes.content}>
			<Grid item>
				<Typography variant="h2" style={{ fontWeight: 700 }} gutterBottom>
					{t('components.categoriesDashboard.supportCards.title')}
				</Typography>

				<Typography variant="subtitle1">
					{t('components.categoriesDashboard.supportCards.subtitle.textStart')}
					<Typography variant="subtitle1" style={{ display: 'inline', fontWeight: 700 }}>
						{t('components.categoriesDashboard.supportCards.onsemi')}
					</Typography>
					{reactStringReplace(
						t('main:components.categoriesDashboard.supportCards.subtitle.textEnd'),
						/(https?:\/\/\S+)/g,
						(match, i) => (
							<Link href={match} key={i} target="_blank" color="#2A78B8" sx={{ display: 'inline' }}>
								<Typography variant="subtitle" color="#2A78B8" display="inline" style={{ fontWeight: 700 }}>
									{t('main:components.categoriesDashboard.supportCards.subtitle.link')}
								</Typography>
							</Link>
						)
					)}
				</Typography>
			</Grid>
			<Grid item container spacing={3}>
				<Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
					<Card className={classes.card}>
						<CardContent>
							<img src={CHAT_ICON} width="64" height="64" alt={'handshake icon'} aria-hidden="true" />
							<Grid className={classes.cardText}>
								<Typography variant="h5" style={{ fontWeight: 700 }}>
									{t('components.categoriesDashboard.supportCards.supportCard.title')}
								</Typography>
								<Typography variant="subtitle1">
									{t('components.categoriesDashboard.supportCards.supportCard.subtitle')}
								</Typography>
							</Grid>
						</CardContent>
						<CardActions>
							<Button color="primary" variant="contained" noTextTransform href="https://www.onsemi.com/support">
								{t('components.categoriesDashboard.supportCards.supportCard.button')}
							</Button>
						</CardActions>
					</Card>
				</Grid>
				<Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
					<Card className={classes.card}>
						<CardContent>
							<img src={HANDSHAKE_ICON} width="64" height="64" alt={'handshake icon'} aria-hidden="true" />
							<Grid className={classes.cardText}>
								<Typography variant="h5" style={{ fontWeight: 700 }}>
									{t('components.categoriesDashboard.supportCards.supportCenterCard.title')}
								</Typography>
								<Typography variant="subtitle1">
									{t('components.categoriesDashboard.supportCards.supportCenterCard.subtitle')}
								</Typography>
							</Grid>
						</CardContent>
						<CardActions>
							<Button color="primary" variant="contained" noTextTransform href="https://community.onsemi.com/s/">
								{t('components.categoriesDashboard.supportCards.supportCenterCard.button')}
							</Button>
						</CardActions>
					</Card>
				</Grid>
				<Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
					<Card className={classes.card}>
						<CardContent>
							<img src={ENVELOPE_ICON} width="64" height="64" alt={'handshake icon'} aria-hidden="true" />
							<Grid className={classes.cardText}>
								<Typography variant="h5" style={{ fontWeight: 700 }}>
									{t('components.categoriesDashboard.supportCards.stayUpdatedCard.title')}
								</Typography>
								<Typography variant="subtitle1">
									{t('components.categoriesDashboard.supportCards.stayUpdatedCard.subtitle')}
								</Typography>
							</Grid>
						</CardContent>
						<CardActions>
							<Button color="primary" variant="contained" noTextTransform href="https://www.onsemi.com/subscribe">
								{t('components.categoriesDashboard.supportCards.stayUpdatedCard.button')}
							</Button>
						</CardActions>
					</Card>
				</Grid>
			</Grid>
		</Grid>
	);
};

export default SupportCards;
